/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { NEGOTIABLE_QUOTE_TEMPLATE_FRAGMENT } from '@/quote-management/api/graphql/NegotiableQuoteTemplateFragment';

export const SET_QUOTE_TEMPLATE_EXPIRATION_DATE_MUTATION = /* GraphQL */ `
  mutation SET_QUOTE_TEMPLATE_EXPIRATION_DATE_MUTATION(
    $templateId: ID!
    $expirationDate: String!
  ) {
    setQuoteTemplateExpirationDate(input: { template_id: $templateId, expiration_date: $expirationDate }) {
      ...NegotiableQuoteTemplateFragment
    }
  }
  ${NEGOTIABLE_QUOTE_TEMPLATE_FRAGMENT}
`;

